export const GlobalProductFlags = [
  {
    value: 1,
    name: "Active",
  },
  {
    value: 2,
    name: "Suspended",
  },
  {
    value: 3,
    name: "Blocked",
  },
  {
    value: 4,
    name: "Unregistered",
  },
];

export const GlobalPerformanceFlags = [
  {
    value: 1,
    name: "Active",
  },
  {
    value: 2,
    name: "Suspended",
  },
  {
    value: 3,
    name: "Blocked",
  },
];

export const EuProductFlags = [
  {
    value: 1,
    name: "Pending",
  },
  {
    value: 2,
    name: "Not Participating in EU",
  },
  {
    value: 3,
    name: "Active",
  },
  {
    value: 4,
    name: "Suspended",
  },
  {
    value: 5,
    name: "Blocked",
  },
  {
    value: 6,
    name: "Unregistered",
  },
];

export const EuPerformanceFlags = [
  {
    value: 1,
    name: "Pending",
  },
  {
    value: 2,
    name: "Not Participating in EU",
  },
  {
    value: 3,
    name: "Active",
  },
  {
    value: 4,
    name: "Suspended",
  },
  {
    value: 5,
    name: "Blocked",
  },
];